export const messages = {
  en: {
    aStaffCommunity: {
      orgPlaceholder: 'Select organization',
      staffPlaceholder: 'Enter staff name',
      linkCommunity: 'Link Community',
      staffName: 'Staff Name',
      staffId: 'Staff ID',
      communityId: 'Community ID',
      communityName: 'Community Name',
      selectStaffFirst: 'Please select a staff first'
    }
  },
  zh: {
    aStaffCommunity: {
      orgPlaceholder: '选择组织',
      staffPlaceholder: '填写员工名称',
      linkCommunity: '关联小区',
      staffName: '员工名称',
      staffId: '员工编号',
      communityId: '小区编号',
      communityName: '小区名称',
selectStaffFirst: '请先选择员工'
    }
  },
  'zh-TW': {
    aStaffCommunity: {
      orgPlaceholder: '選擇組織',
      staffPlaceholder: '填寫員工名稱',
      linkCommunity: '關聯小區',
      staffName: '員工名稱',
      staffId: '員工編號',
      communityId: '小區編號',
      communityName: '小區名稱',
      selectStaffFirst: '請先選擇員工'
    }
  }
}